export default "__VITE_ASSET__HSBgkRa5__"